import { notification } from 'antd'
import { useQuery } from 'react-query'

import { QUERY_KEYS } from '@api'

import { getMgmts } from './api'

const onError = () => {
  notification.error({
    message: 'Error al obtener los mgmts',
  })
}

interface MgmtsFilters {
  description?: string
}

const useMgmts = (filters?: MgmtsFilters) => {
  const { data: mgmts, isLoading: mgmtsIsLoading } = useQuery(
    [QUERY_KEYS.MGMTS, filters],
    () => getMgmts(filters),
    {
      staleTime: Infinity,
      onError,
    },
  )

  return {
    mgmts,
    mgmtsIsLoading,
  }
}

export default useMgmts
